import "components/Contact/ContactBlock.scss";
import {WagtailImage} from "components/Wagtail/WagtailImage";
import {convertHtmlToReact} from "@hedgedoc/html-to-react/dist/convertHtmlToReact";
import Button from "components/reusable/Button/Button";
import React from "react";
import { toggleModal } from "store/reducers/modal/modalSlice";
import {useDispatch} from "react-redux";
import ContactModal from "components/Modals/Contact/Contact";


const ContactBlock = ({ image, title, subContactBlock }) => {
  const dispatch = useDispatch();

  const handleClick = (block) => {
    if (block.value.url) {
      window.location.href = block.value.url;
    } else {
      dispatch(toggleModal({
        children: <ContactModal />
      }));
    }
  };

  const handleKeyDown = (block, e) => {
    if (e.key === "Enter") {
      window.location.href = block.value.btn_url;
    }
  };


  return (
    <div className="contact-block-container">
      <div className="resi-container">
        <div className="resi-margin-container">
          <div className="contact-block-header">
            <div className="contact-block-image">
              <WagtailImage height={115} image={image}/>
            </div>
            <div className="contact-block-header-title" tabIndex="0">{convertHtmlToReact(title)}</div>
          </div>
          <div className="sub-contact-blocks-container">
            {subContactBlock?.length > 0 && subContactBlock.map((block, index) => {
              if (block.type === "text_button_component") {
                return (
                  <div className="sub-contact-block-item-container" key={index}>
                    <div className="title-text">
                      {convertHtmlToReact(block.value.title_text)}
                    </div>
                    <div className="description-text">
                      {convertHtmlToReact(block.value.description)}
                    </div>

                    <Button
                      btnStyle={"beanfield-button--hollow"}
                      style={{
                        borderColor: "#00663E",
                        fontWeight: 700,
                        color: "#00663E",
                        marginTop: "1.5rem",
                      }}
                      click={() => handleClick(block) }
                      onKeyDown={(e) => handleKeyDown(block, e)}
                    >
                      {block.value.btn_text}
                    </Button>
                  </div>
                );
              } else {
                return (
                  <div className="sub-contact-block-item-container" key={index}>
                    <div className="title-text">
                      {convertHtmlToReact(block.value.title_text)}
                    </div>
                    <div className="description-text">
                      {convertHtmlToReact(block.value.description)}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
)
};

export default ContactBlock;
